import vehicleService from '@/services/vehicle-service'

function getNewState() {
  return {
    categoriesVehicles: [],
    sous_categoriesVehicles: [],
  }
}

export default {
  state: getNewState(),
  getters: {
    getCategoriesVehicles(state) {
      return state.categoriesVehicles
    },
    getSousCategoriesVehicles(state) {
      return state.sous_categoriesVehicles
    },
    getVehicule(state) {
      return state.vehicule
    },
  },
  mutations: {
    setCategoriesVehicles(state, infos = []) {
      state.categoriesVehicles = infos
    },
    setSousCategoriesVehicles(state, infos = []) {
      state.sous_categoriesVehicles = infos
    },
  },
  actions: {
    // async initializeVehicle({state, commit}) {
    async initializeVehicle({ commit }) {
      let vehicleCategoriestList = await vehicleService.fetchVehicleCategories(
        vehicleService.normalizeVehicleCategoryToV2
      )

      let vehiclesList = await vehicleService.fetchVehicles((v) => {
        return vehicleService.normalizeVehicleToV2(v, vehicleCategoriestList)
      })

      commit('setCategoriesVehicles', vehicleCategoriestList)
      commit('setSousCategoriesVehicles', vehiclesList)
    },
  },
}
